<template>
  <v-form
    ref="formEditValid"
    v-model="validEdit"
    lazy-validation>
    <v-card dark>
      <!-- <v-card-title>Edit this chart</v-card-title> -->
      <!--<v-toolbar flat>-->
        <!--<v-toolbar-title>Edit this chart</v-toolbar-title>-->
        <!--<v-spacer></v-spacer>-->
        <!--<v-btn @click="$emit('close')" icon>-->
          <!--<v-icon>close</v-icon>-->
        <!--</v-btn>-->
      <!--</v-toolbar>-->
      <v-card-text style="min-height: 300px;">
        <v-text-field
          v-model="chartName"
          :rules="[v => !!v || 'Chart name is required']"
          label="Chart name"
          @change="preview"
          required/>
      <div v-if="chartType ==='x-pie'">
        <v-select
          v-model="chartType"
          :items="chartTypeOptions"
          :rules="allRules"
          label="Chart type"
          v-if="chartFunc='count'"
          @change="preview"
          required/>
      </div>
      <div v-else>
        <v-select
          v-model="chartType"
          :items="chartTypeOptions"
          :rules="allRules"
          label="Chart type"
          @change="preview"
          required/>
      </div>
        <v-select
          v-model="index_now"
          :items="index_list"
          :rules="allRules"
          label="Device"
          @change="setRefreshIndex(); preview();"
          required/>
        <div v-if="chartType === 'x-sankey'">
          <v-select
            v-model="chartFunc"
            :items="chartFieldByteOptions"
            :rules="[v => !!v || 'Math function is required']"
            label="Sort by"
            @change="preview"
            required/>
          <v-text-field
            v-model="chartTopLimitSankey"
            :rules="[v => !!v || 'Size is required']"
            label="Size of data in the chart (Default 5)"
            @change="preview"
            required/>
          <v-select
            v-if="chartFunc === 'byte'"
            v-model="chartFuncByte"
            :items="chartFieldByteOptions"
            :rules="[v => !!v || 'Math function is required']"
            :label="fieldResponse"
            @change="preview"
            required/>
          <v-autocomplete
            v-model="chartFieldStart"
            :items="chartFieldOptions"
            :rules="[v => !!v || 'Field start is required']"
            :label="'Dashboard field Start('+ chartFieldOptions.length+' Field available)'"
            @change="preview"
            required>
            <v-slide-x-reverse-transition
              slot="append-outer"
              mode="out-in"/>
          </v-autocomplete>
          <v-autocomplete
            v-model="chartFieldEnd"
            :items="chartFieldOptions"
            :rules="[v => !!v || 'Field end is required']"
            :label="'Dashboard field End('+ chartFieldOptions.length+' Field available)'"
            @change="preview"
            required>
            <v-slide-x-reverse-transition
              slot="append-outer"
              mode="out-in"/>
          </v-autocomplete>
          <v-text-field
            v-model="subFilter"
            :rules="[v => !!v || 'Sub filter is required']"
            label="Filter (Default *)"
            @change="preview"
            required/>
        </div>
        <div v-else-if="chartType === 'x-table'">
          <v-autocomplete
            v-for="(item, index) in xTableItems"
            v-model="item.value"
            :items="chartFieldOptions"
            :key="index"
            :rules="[v => !!v || 'Table field is required']"
            :label="'Select Field Table ('+ chartFieldOptions.length+' Field available)'"
            persistent-hint
            @change="preview"
            perpend-icon="table_chart">
            <v-slide-x-reverse-transition
              slot="append-outer"
              mode="out-in">
              <v-icon
                :color="'warning'"
                @click="xTableItems.splice(index, 1); preview();"
                v-text="'delete'"/>
            </v-slide-x-reverse-transition>
          </v-autocomplete>
          <v-layout
            align-center
            justify-space-around>
            <v-icon
              @click="xTableItems.push({ value: '' })">playlist_add</v-icon>
          </v-layout>
          <v-text-field
            v-model="subFilter"
            :rules="[v => !!v || 'Sub filter is required']"
            label="Filter (Default *)"
            @change="preview"
            required/>
        </div>
        <div v-else-if="chartType === 'x-tableCustom'">
          <!-- Select Field Table @timestamp -->
          <!-- <v-select
            v-model="timestamp"
            :items="timestamp"
            item-text="text"
            item-value="value"
            label="Select Field Table"
            disabled
          /> -->
          <!-- Other Select Field Table -->
          <v-autocomplete v-model="item.value" :rules="allRules" v-for="(item, index) in xTableItems" :key="index"
            :items="chartFieldOptions"
            :label="'Select Field Table ('+ chartFieldOptions.length+' Field available)'"
            @change="preview"
            perpend-icon="table_chart">
            <v-slide-x-reverse-transition slot="append-outer" mode="out-in">
              <v-icon :color="'warning'" @click="xTableItems.splice(index, 1); preview();" v-text="'delete'"/>
            </v-slide-x-reverse-transition>
          </v-autocomplete>
          <!-- add item Select Field Table -->
          <v-layout align-center justify-space-around v-if="xTableItems.length < 4">
            <v-icon @click="xTableItems.push({ value: '' })">playlist_add</v-icon>
          </v-layout>
          <!-- Count or BandWidth first field  -->
          <v-select
            v-model="xTableItemfirst"
            :label="'Count or BandWidth'"
            :items="sumFieldOptions"
            :rules="allRules"
            @change="preview"
          ></v-select>
          <!-- <v-autocomplete v-model="item.value" :rules="allRules" v-for="(item, index) in xTableItemfirst" :key="index"
            :items="sumFieldOptions"
            :label="'Count or BandWidth'"
            perpend-icon="table_chart"
          /> -->
          <!-- Count or BandWidth -->
          <v-autocomplete v-model="item.value" :rules="allRules" v-for="(item, index) in xTableItem" :key="index"
            :items="sumFieldOptions"
            :label="'Count or BandWidth'"
            @change="preview"
            perpend-icon="table_chart">
            <v-slide-x-reverse-transition slot="append-outer" mode="out-in">
              <v-icon :color="'warning'" @click="xTableItem.splice(index, 1); preview();" v-text="'delete'"/>
            </v-slide-x-reverse-transition>
          </v-autocomplete>
          <!-- add item Count or BandWidth -->
          <v-layout align-center justify-space-around v-if="xTableItem.length < 2">
            <v-icon @click="xTableItem.push({ value: '' })">playlist_add</v-icon>
          </v-layout>
          <!-- interval -->
          <v-select v-model="interval" :rules="allRules" label="Interval time (Default Auto)"
                    :items="intervaltype"
                    @change="preview"
                    required/>
          <!-- sub filter -->
          <v-text-field v-model="subFilter" :rules="allRules" label="Filter (Default *)" @change="preview" required/>
        </div>
        <div v-else-if="chartType === 'x-summary'">
        <v-text-field v-model="subFilter" label="Sub Filter (Default *)" @change="preview" :rules="[v => !!v || 'Subfilter is required']" required/>
        </div>
        <div v-else-if="chartType === 'x-map'">
          <v-text-field
            v-model="subFilter"
            :rules="[v => !!v || 'Sub filter is required']"
            label="Filter (Default *)"
            @change="preview"
            required/>
        </div>
        <div v-else-if="chartType === 'x-timeBar'">
          <v-select v-model="interval" :rules="allRules" label="Interval time (Default Auto)"
                    :items="intervaltype"
                    @change="preview"
                    required/>
        </div>
        <div v-else>
          <div v-if="chartType === 'x-pie'">
          <v-select
                    v-model="chartFunc"
                    :rules="allRules" label="Sort by"
                    :items="chartFuncPie"
                    @change="preview"
                    required/>
          </div>
          <div v-else>
          <v-select
                    v-model="chartFunc"
                    :rules="allRules" label="Sort by"
                    :items="chartFieldByteOptions"
                    @change="preview "
                    required/>
          </div>
          <v-text-field v-model="chartTopLimit" label="Size of data in the chart (Default 10)" :rules="[v => !!v || 'Size is required']" @change="preview" required/>
          <v-select
            v-if="chartFunc === 'byte'"
            v-model="chartFuncByte"
            :items="chartFieldByteOptions"
            :rules="[v => !!v || 'Math function is required']"
            :label="fieldResponse"
            @change="preview"
            required/>
          <v-autocomplete
            v-model="chartField"
            :items="chartFieldOptions"
            :rules="[v => !!v || 'Dashboard field is required']"
            :label="'Dashboard field ('+ chartFieldOptions.length+' Field available)'"
            @change="preview"
            required>
            <v-slide-x-reverse-transition
              slot="append-outer"
              mode="out-in"/>
          </v-autocomplete>
          <v-text-field v-model="subFilter" label="Sub Filter (Default *)" :rules="[v => !!v || 'Subfilter is required']" @change="preview" required/>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          slot="activator"
          fab
          large
          color="#00BFA5"
          icon
          @click.native="commit">
          <v-icon>arrow_forward</v-icon>
        </v-btn>
        <!-- <v-btn
          slot="activator"
          flat
          icon
          @click.native="$emit('close')">
          <v-icon>cancel</v-icon>
        </v-btn> -->
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
export default {
  props: {
    initialSlice: {
      type: Object,
      default: function () {
        return {}
      }
    },
    chartTypeOptions: {
      type: Array,
      default: function () {
        return []
      }
    },
    chartFieldOptions: {
      type: Array,
      default: function () {
        return []
      }
    },
    chartFieldByteOptions: {
      type: Array,
      default: function () {
        return []
      }
    },
    fieldResponse: {
      type: String,
      default: ''
    },
    sumFieldOptions: Array,
    index_list: {
      type: Array
    },
    index: {
      type: String
    },
    preview_slices: {
      type: []
    }
  },
  data () {
    return {
      slice: {},
      xTableItems: [{
        value: ''
      }],
      xTableItem: [],
      xTableItemfirst: null,
      xTableFields: [],
      xTableOptions: [],
      xTableFieldsCustom: [],
      xTableOptionsCustom: [],
      fieldCustom: [],
      optionsCustom: [],
      chartName: '',
      chartType: '',
      chartFunc: '' || 'Count',
      chartFuncPie: '' || [{
        text: 'Count',
        value: 'count'
      }],
      chartFuncByte: '',
      chartField: '',
      chartFieldStart: '',
      index_now: '',
      chartFieldEnd: '',
      subFilter: '',
      chartTopLimit: '10',
      chartTopLimitSankey: '5',
      validEdit: true,
      // timestamp: { text: '@timestamp', value: '@timestamp' },
      allRules: [
        v => !!v || 'This is required'
      ],
      interval: 'auto',
      intervaltype: [
        {
          text: 'Auto',
          value: 'auto'
        },
        {
          text: 'minutes (m)',
          value: '1m'
        },
        {
          text: 'hours (h)',
          value: '1h'
        },
        {
          text: 'days (d)',
          value: '1d'
        },
        {
          text: 'weeks (w)',
          value: '1w'
        },
        {
          text: 'months (M)',
          value: '1M'
        },
        {
          text: 'years (y)',
          value: '1y'
        }
      ]
    }
  },
  created () {
    this.index_now = this.index
  },
  methods: {
    preview () {
      if (this.$refs.formEditValid.validate()) {
        // Filter the original slice's property for only i, x, y, w, h
        let baseSlice = (({ i, x, y, w, h }) => ({ i, x, y, w, h }))(this.slice)
        if (this.chartType === 'x-table') {
          // set Fields of x-table
          this.xTableFields = this.xTableItems.map(item => ({ key: item.value, sortable: true }))
          // Re-insert '@timestamp' at the first index
          this.xTableFields.unshift({ key: '@timestamp', sortable: true })
          // Re-insert 'rawData' at the last index
          this.xTableFields.push({ key: 'rawData', sortable: false })
          this.xTableOptions = this.xTableItems.map(item => ({ text: item.value, value: item.value }))
        }
        if (this.chartType === 'x-tableCustom') {
          // set Fields of x-tableCustom
          this.xTableFieldsCustom = this.xTableItems.map(item => ({ key: item.value, sortable: true }))
          // Re-insert '@timestamp' at the first index
          // this.xTableFieldsCustom.unshift({ key: this.timestamp.value, sortable: true })
          // set Option of x-tableCustom
          this.xTableOptionsCustom = this.xTableItems.map(item => ({ text: item.value, value: item.value }))
          // Re-insert '@timestamp' at the first index
          // this.xTableOptionsCustom.unshift({ text: this.timestamp.value, value: this.timestamp.value })
          // set FieldsCustom  of x-tableCustom etc. count download uolpad
          this.fieldCustom = this.xTableItem.map(item => ({ key: item.value, sortable: true }))
          // Re-insert 'cout or upload or download' at the first index of fieldCustom
          this.fieldCustom.unshift({ key: this.xTableItemfirst, sortable: true })
          // set OptionCustom  of x-tableCustom etc. count download uolpad
          this.optionsCustom = this.xTableItem.map(item => ({ text: item.value, value: item.value }))
          // Re-insert 'cout or upload or download' at the first index of optionsCustom
          this.optionsCustom.unshift({ text: this.xTableItemfirst, value: this.xTableItemfirst })
        }
        this.slice = {}
        this.slice = {
          /* Set new slice_id because Vue will re-render the chart by
          :key props, which is slice_id */
          slice_id: new Date().getTime().toString(),
          ...baseSlice,
          chartName: this.chartName,
          chartType: this.chartType,
          index: this.index_now,
          subFilter: this.subFilter,
          ...(this.chartType === 'x-sankey' && {
            orderby: this.chartFunc === 'count'
              ? '_count'
              : 'sumbyte',
            fieldsum: this.chartFunc === 'download'
              ? 'bytes_in'
              : this.chartFunc === 'upload'
                ? 'bytes_out'
                : '',
            field_st: this.chartFieldStart + '.keyword',
            field_nd: this.chartFieldEnd + '.keyword',
            topLimit: this.chartTopLimitSankey
          }),
          ...(this.chartType === 'x-summary' && {
          }),
          ...(this.chartType === 'x-map' && {
          }),
          ...(this.chartType === 'x-table' && {
            fields: this.xTableFields,
            options: this.xTableOptions
          }),
          ...(this.chartType === 'x-tableCustom' && {
            fields: this.xTableFieldsCustom,
            options: this.xTableOptionsCustom,
            fieldCustom: this.fieldCustom,
            optionsCustom: this.optionsCustom,
            intervalTimeBar: this.interval
          }),
          ...((this.chartType === 'x-bar' || this.chartType === 'x-hbar' || this.chartType === 'x-pie') && {
            orderby: this.chartFunc === 'count'
              ? '_count'
              : 'sumbyte',
            fieldsum: this.chartFunc === 'download'
              ? 'bytes_in'
              : this.chartFunc === 'upload'
                ? 'bytes_out'
                : '',
            field: this.chartField + '.keyword',
            topLimit: this.chartTopLimit
          }),
          ...(this.chartType === 'x-timeBar' && {
            intervalTimeBar: this.interval
          })
        }
        this.$emit('preview', this.slice)
      }
    },
    commit () {
      if (this.$refs.formEditValid.validate()) {
        // Filter the original slice's property for only i, x, y, w, h
        let baseSlice = (({ i, x, y, w, h }) => ({ i, x, y, w, h }))(this.slice)
        if (this.chartType === 'x-table') {
          // set Fields of x-table
          this.xTableFields = this.xTableItems.map(item => ({ key: item.value, sortable: true }))
          // Re-insert '@timestamp' at the first index
          this.xTableFields.unshift({ key: '@timestamp', sortable: true })
          // Re-insert 'rawData' at the last index
          this.xTableFields.push({ key: 'rawData', sortable: false })
          this.xTableOptions = this.xTableItems.map(item => ({ text: item.value, value: item.value }))
        }
        if (this.chartType === 'x-tableCustom') {
          // set Fields of x-tableCustom
          this.xTableFieldsCustom = this.xTableItems.map(item => ({ key: item.value, sortable: true }))
          // Re-insert '@timestamp' at the first index
          // this.xTableFieldsCustom.unshift({ key: this.timestamp.value, sortable: true })
          // set Option of x-tableCustom
          this.xTableOptionsCustom = this.xTableItems.map(item => ({ text: item.value, value: item.value }))
          // Re-insert '@timestamp' at the first index
          // this.xTableOptionsCustom.unshift({ text: this.timestamp.value, value: this.timestamp.value })
          // set FieldsCustom  of x-tableCustom etc. count download uolpad
          this.fieldCustom = this.xTableItem.map(item => ({ key: item.value, sortable: true }))
          // Re-insert 'cout or upload or download' at the first index of fieldCustom
          this.fieldCustom.unshift({ key: this.xTableItemfirst, sortable: true })
          // set OptionCustom  of x-tableCustom etc. count download uolpad
          this.optionsCustom = this.xTableItem.map(item => ({ text: item.value, value: item.value }))
          // Re-insert 'cout or upload or download' at the first index of optionsCustom
          this.optionsCustom.unshift({ text: this.xTableItemfirst, value: this.xTableItemfirst })
        }
        this.slice = {
          /* Set new slice_id because Vue will re-render the chart by
          :key props, which is slice_id */
          slice_id: new Date().getTime().toString(),
          ...baseSlice,
          chartName: this.chartName,
          chartType: this.chartType,
          index: this.index_now,
          subFilter: this.subFilter,
          ...(this.chartType === 'x-sankey' && {
            orderby: this.chartFunc === 'count'
                      ? '_count'
                      : 'sumbyte',
            fieldsum: this.chartFunc === 'download'
                ? 'bytes_in'
              : this.chartFunc === 'upload'
                ? 'bytes_out'
              : '',
            field_st: this.chartFieldStart + '.keyword',
            field_nd: this.chartFieldEnd + '.keyword',
            topLimit: this.chartTopLimitSankey
          }),
          ...(this.chartType === 'x-summary' && {
          }),
          ...(this.chartType === 'x-map' && {
          }),
          ...(this.chartType === 'x-table' && {
            fields: this.xTableFields,
            options: this.xTableOptions
          }),
          ...(this.chartType === 'x-tableCustom' && {
            fields: this.xTableFieldsCustom,
            options: this.xTableOptionsCustom,
            fieldCustom: this.fieldCustom,
            optionsCustom: this.optionsCustom,
            intervalTimeBar: this.interval
          }),
          ...((this.chartType === 'x-bar' || this.chartType === 'x-hbar' || this.chartType === 'x-pie') && {
            orderby: this.chartFunc === 'count'
                      ? '_count'
                      : 'sumbyte',
            fieldsum: this.chartFunc === 'download'
              ? 'bytes_in'
              : this.chartFunc === 'upload'
                ? 'bytes_out'
                : '',
            field: this.chartField + '.keyword',
            topLimit: this.chartTopLimit
          }),
          ...(this.chartType === 'x-timeBar' && {
            intervalTimeBar: this.interval
          })
        }
        this.$emit('commit', this.slice)
      }
    },
    setRefreshIndex () {
      this.$emit('setRefreshIndex', this.index_now)
    }
  },
  watch: {
    chartType: function (chartType) {
      if (chartType !== this.slice.chartType) {
        this.xTableItems = chartType === 'x-tableCustom' || chartType === 'x-table'
                            ? [{value: ''}]
                            : []
        this.$refs.formEditValid.resetValidation()
      }
    },
    initialSlice: function (slice) {
      this.slice = slice
      this.chartName = slice.chartName
      this.chartType = slice.chartType
      this.setRefreshIndex(slice.index)
      this.index_now = slice.index
      this.subFilter = slice.subFilter
      if (this.chartType === 'x-sankey') {
        this.chartFunc = slice.orderby === 'sumbyte' && slice.fieldsum === 'bytes_in'
          ? 'download'
          : slice.orderby === 'sumbyte' && slice.fieldsum === 'bytes_out'
            ? 'upload'
            : slice.orderby === '_count'
              ? 'count'
              : 'count'
        this.chartFuncByte = slice.orderby === 'sumbyte'
          ? slice.fieldsum
          : ''
        this.chartFieldStart = slice.field_st.split('.')[0]
        this.chartFieldEnd = slice.field_nd.split('.')[0]
        this.chartTopLimitSankey = slice.topLimit
      } else if (this.chartType === 'x-table') {
        this.xTableItems = slice.fields.map(field => ({ value: field.key }))
        this.xTableItems.shift() // Delete '@timestamp'
        this.xTableItems.pop() // Delete 'rawData'
      } else if (this.chartType === 'x-tableCustom') {
        this.xTableItems = slice.fields.map(field => ({value: field.key}))
        // this.xTableItems.shift() // Delete '@timestamp'
        this.xTableItem = slice.fieldCustom.map(fieldCustom => ({ value: fieldCustom.key }))
        // this.xTableItemfirst.push(this.xTableItem[0])
        this.xTableItemfirst = this.xTableItem[0].value // add first field
        this.xTableItem.shift() // Delete first field
        this.interval = slice.intervalTimeBar // interval
      } else if (this.chartType === 'x-timeBar') {
        this.interval = slice.intervalTimeBar
      } else {
        this.chartFunc = slice.orderby === 'sumbyte' && slice.fieldsum === 'bytes_in'
                            ? 'download'
                          : slice.orderby === 'sumbyte' && slice.fieldsum === 'bytes_out'
                            ? 'upload'
                          : slice.orderby === '_count'
                            ? 'count'
                          : 'count'
        this.chartFuncByte = slice.orderby === 'sumbyte'
                              ? slice.fieldsum
                              : ''
        this.chartField = slice.field.split('.')[0]
        this.chartTopLimit = slice.topLimit
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DashboardDialogEditChart.vue